import React from "react";
import { css } from "@emotion/css";
import { useI18n } from "../i18n";

const LanguageSwitcher = ({ variant = "desktop" }) => {
  const { lang, setLang, t, langs } = useI18n();
  const isMobile = variant === "mobile";
  const isTopbar = variant === "topbar";
  // Mobile menu panel background is light pink (#ffd7f8) -> dark text there;
  // desktop header pill is dark -> white text.
  const fg = isMobile ? "#121212" : "#FFF";
  // Topbar = always-visible dark pill button on the mobile header bar.
  const bg = isTopbar ? "rgba(18,18,18,0.85)" : "transparent";
  const underlineColor = isMobile ? "rgba(18,18,18,0.4)" : "rgba(255,255,255,0.45)";

  const style = css({
    fontFamily: "Syne, sans-serif",
    fontSize: isTopbar ? 14 : isMobile ? 20 : 14,
    fontWeight: 600,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: fg,
    background: bg,
    border: isTopbar ? "1px solid rgba(255,255,255,0.35)" : "none",
    borderRadius: isTopbar ? 8 : 0,
    borderBottom: isTopbar ? undefined : `1px solid ${underlineColor}`,
    padding: isTopbar ? "6px 10px" : "2px 2px 2px 2px",
    cursor: "pointer",
    maxWidth: isTopbar ? 96 : isMobile ? 130 : 120,
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    option: {
      color: "#121212",
      background: "#FFF",
      textTransform: "none",
      fontFamily: "Inter, sans-serif",
      fontSize: 14,
    },
    "&:hover": {
      textDecoration: "underline",
    },
  });

  return (
    <select
      className={style}
      value={lang}
      onChange={(e) => setLang(e.target.value)}
      aria-label={t("lang_selector_label")}
    >
      {langs.map((code) => (
        <option key={code} value={code}>
          {t(`lang_name_${code}`)}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
